// @flow
import { handleActions } from 'redux-actions';
import { ADD_FORM, REMOVE_FORM } from './constants';


export type Form = {
    +schema: Object,
    +buttonLabel: ?string,
    +title: ?string,
    +modal: ?boolean,
    +requestKey: ?string,
    +executionId: string,
    +rootExecutionId: ?string,
    +initialData: ?Object,
};

export type State = { +[string]: Form };


const initialState: State = {};

const reducer = handleActions({
    [ADD_FORM]: (state: State, { payload }: {
        payload: {
            code: string,
            executionId: string,
            rootCode: ?string,
            rootExecutionId: ?string,
            schema: Object,
            initialData: Object,
            buttonLabel: ?string,
            title: ?string,
            modal: ?boolean,
            requestKey: ?string,
        }
    }) => {
        const {
            code, schema, buttonLabel, title, modal, requestKey, rootCode, executionId, rootExecutionId, initialData,
        } = payload;

        // TODO: maybe add option for multiple forms per workflow code?
        return {
            ...state,
            [rootCode || code]: {
                schema, buttonLabel, title, modal, requestKey, errors: {}, executionId, rootExecutionId, initialData,
            },
        };
    },
    [REMOVE_FORM]: (state: State, { payload }: {
        payload: {
            code: string,
            executionId: string,
        },
    }) => {
        const newState = { state };
        delete newState[payload.code];

        return newState;
    },
}, initialState);

export default reducer;
